import React from "react";
import { Accordion, Card } from "react-bootstrap";
import TestCaseDetailsComponent from "./TestCaseDetailsComponent";
import TestExecutionForm from "./TestExecutionForm";
import UpdateTestScriptsAlert from "./UpdateTestScriptsAlert";
import TestStepsComponent from "./test-steps/TestScriptsComponent";
import Comments from "../../../elements/common/comments/Comments";
import LinkedIssue from "../../../elements/common/traceability/LinkedIssue";
import Attachments from "../../../elements/common/attachments/Attachments";
import { useLocation, useParams } from "react-router-dom";
import FailuresAnalysis from "./FailuresAnalysis";
import { isExecutiveManager } from "../../../../lib/userUtils";
import { getTestCycleKeyFromLocation } from "../../../../lib/executionUtils";

const entityType = "Execution";
const TestExecutionAccordionBody = ({
  execution,
  data,
  users,
  fetchSelectedExecutionDetails,
  elapsedTime,
  isTestCycleCompleted, 
  loading,
  labels,
}) => {
  const { projectId } = useParams();

  const location = useLocation();
  const testCycleKey = getTestCycleKeyFromLocation(location)
  return (
    <Accordion.Body>
      <Card>
        <Card.Header
          className="d-flex justify-content-between align-items-center"
          style={{ height: "60px" }}
        >
          <h5>Execution</h5>
        </Card.Header>
        <Card.Body>
          <TestExecutionForm
            execution={execution}
            users={users}
            elapsedTime={elapsedTime}
            loading={loading}
          />
        </Card.Body>
      </Card>
      <Card className="mt-2">
        <Card.Header
          className="d-flex justify-content-between align-items-center"
          style={{ height: "60px" }}
        >
          <h5>Test Case Details</h5>
        </Card.Header>
        <Card.Body>
          <TestCaseDetailsComponent testCase={data} projectId={projectId} labels={labels} />
        </Card.Body>
      </Card>
      {!isExecutiveManager() && (
        <div className="mt-2">
          <UpdateTestScriptsAlert
            execution={execution}
            data={data}
            fetchSelectedExecutionDetails={fetchSelectedExecutionDetails}
          />
        </div>
      )}
      <div className="mt-2">
        <TestStepsComponent
          data={data}
          execution={execution}
          isTestCycleCompleted={isTestCycleCompleted}
          fetchSelectedExecutionDetails={fetchSelectedExecutionDetails}
          projectId={projectId}
        />
      </div>
      {execution && execution?.status?.name === "Fail" && (
        <div className="mt-2">
          <FailuresAnalysis
            executionId={execution?.id}
            testCaseId={execution?.association?.test_case_id}
          />
        </div>
      )}
      <div className="mt-2">
        <LinkedIssue
          entityId={execution?.id}
          entityKey={execution?.key}
          entityType={entityType}
          isShowSuggestion={execution?.status?.name === "Fail"}
          data={data}
          showWarning={execution?.status?.name === "Fail" ? true : false}
        />
      </div>

      <div className="mt-2">
        <Attachments
          users={users}
          entityType={entityType}
          entityId={execution?.id}
        />
      </div>
      <div className="mt-2">
        <Comments
          entityId={execution?.id}
          otherData={{ testCaseKey: data?.key, testCycleKey: testCycleKey }}
          entityType={entityType}
          users={users}
          entityKey={execution?.key}
          isEditable={execution?.is_editable ? true : false}
        />
      </div>
    </Accordion.Body>
  );
};

export default TestExecutionAccordionBody;
